<template>
  <div class="card4">
    <div class="bg" :style="{backgroundImage: 'url(' + item.cover + ')'}" @click="goDetail">
      <div class="nft_icon" v-if="isNft"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'card4',
  props: [ 'item' ],
  computed: {
    // 是否是数藏稿
    isNft () {
      return this.item.type === 1 &&
        this.item.isLink &&
        this.item.content.indexOf( 'https://my-h5news-test.app.xinhuanet.com/xhdc/' ) === 0
    },
  },
  methods: {
    // 打开详情
    goDetail () {
      this.$emit( 'pauseMedia' )
      window.goDetail( this.item )
    }
  }
}
</script>

<style scoped>
.card4 {
  width: 100%;
  height: 93px;
  background-image: url("../../../assets/images1/recommend/showType1_bg.png");
  background-size: cover;
  padding: 5px;
  box-sizing: border-box;
  margin-bottom: 12px;
  border-radius: 12px;
  box-shadow: 0 5px 10px rgba(0, 0, 0, 6%);
}

.bg {
  width: 100%;
  height: 100%;
  border-radius: 12px;
  margin: 0 auto;
  background-size: cover;
  background-position: 50%;
  position: relative;
}

.nft_icon {
  width: 32px;
  height: 16px;
  background-image: url("../../../assets/images1/card/nft_icon.png");
  background-size: cover;
  background-position: 50%;
  background-repeat: no-repeat;
  position: absolute;
  left: 4px;
  bottom: 4px;
  z-index: 1;
}
</style>